import { Component, DOCUMENT, Inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-health-care-challenges',
  imports: [TranslateModule],
  templateUrl: './health-care-challenges.component.html',
  styleUrl: './health-care-challenges.component.scss',
})
export class HealthCareChallengesComponent {}
